<ng-container *dsRenderOnlyForBrowser="true">
  <div ngbDropdown class="navbar-nav" *ngIf="moreThanOneLanguage" display="dynamic" placement="bottom-right">
    <button role="button"
            [attr.aria-label]="'nav.language' |translate"
            aria-controls="language-menu-list"
            aria-haspopup="menu"
            [title]="'nav.language' | translate" class="dropdown-toggle btn btn-link px-0"
            (click)="$event.preventDefault()" data-toggle="dropdown" ngbDropdownToggle
            data-test="lang-switch"
            tabindex="0">
      <i class="fas fa-globe-asia fa-lg fa-fw"></i>
    </button>
    <div ngbDropdownMenu class="dropdown-menu" role="listbox" [attr.aria-label]="'nav.language' |translate" id="language-menu-list">
      <div class="dropdown-item" tabindex="0" role="option" #langSelect *ngFor="let lang of translate.getLangs()"
           [lang]="lang"
           (keyup.enter)="useLang(lang)"
           (click)="useLang(lang)"
           [attr.aria-selected]="lang === translate.currentLang"
           [class.active]="lang === translate.currentLang">
        {{ langLabel(lang) }}
      </div>
    </div>
  </div>
</ng-container>
